module.exports = __webpack_public_path__ + "static/media/img_8.87cf4cee.png";